import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="relative overflow-hidden bg-primary-500 px-6 py-12 md:px-14 md:py-16">
          <span className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-400/40" aria-hidden="true" />
          <span className="pointer-events-none absolute -bottom-20 right-24 h-40 w-40 rounded-full bg-accent-500/25" aria-hidden="true" />
          <div className="relative max-w-2xl">
            <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              有线索？我们更想听到你的版本
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-primary-100 md:text-base">
              无论是补充时间线、指出信息错误，还是提供可核实的公开来源，都欢迎投稿。核实之后，我们会把新的信息补进话题页。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="whitespace-nowrap bg-background-50 px-6 py-3 text-center text-sm font-medium text-primary-700 transition-colors hover:bg-accent-100"
              >
                投稿线索
              </Link>
              <Link
                to="/topics"
                className="whitespace-nowrap border border-primary-200 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                先逛逛话题广场
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}